module.exports = __webpack_public_path__ + "static/img/Videoamp-Selected.e189d41.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/Videoamp-Selected.png
// module id = 1576
// module chunks = 0